export enum WalletVersion {
  V3R1 = 0,
  V3R2 = 1,
  V4R1 = 2,
  V4R2 = 3,
  V5_BETA = 4,
  V5R1 = 5,
}
